'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var styles$i = require('./styles-9077e262.js');

var LabelBlock = function (_a) {
    var backgroundImageUrl = _a.backgroundImageUrl, label = _a.label, onClick = _a.onClick, className = _a.className, isGhostVariant = _a.isGhostVariant;
    return (React__default.createElement(styles$i.Container, { className: className + "-container", "data-testid": className + "-container" }, isGhostVariant ? (React__default.createElement(styles$i.GhostLabelBlock, { className: className + "-ghost", "data-testid": className + "-ghost" })) : (React__default.createElement(styles$i.StyledLabelBlock, { backgroundImageUrl: backgroundImageUrl, className: className, "data-testid": className, onClick: onClick },
        React__default.createElement(styles$i.LabelBlockText, { className: className + "-text", "data-testid": className + "-text" }, label)))));
};

exports.LabelBlock = LabelBlock;
